import { render, staticRenderFns } from "./intent-classification.vue?vue&type=template&id=539c109d"
import script from "./intent-classification.vue?vue&type=script&lang=js"
export * from "./intent-classification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports